var S;(function(S){S[S["DAYS"]=0]="DAYS";S[S["MONTHS"]=1]="MONTHS";S[S["YEARS"]=2]="YEARS"})(S||(S={}));export{S as EDateInputPickerModes};
//# sourceMappingURL=enums.js.map
